import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DistributorsResolver } from './resolvers/distributors.resolver';
import { DistributorsComponent } from './distributors.component';
import { DistributorDetailComponent } from './distributor-detail/distributor-detail.component';
import { DistributorResolver } from './resolvers/distributor.resolver';
import { DistributorContractResolver } from './resolvers/distributor-contract.resolver';
import { DistributorProductResolver } from './resolvers/distributor-product.resolver';
import { DistributorContractDetailComponent } from './distributor-contract-detail/distributor-contract-detail.component';
import { DistributorProductDetailComponent } from './distributor-product-detail/distributor-product-detail.component';
import { TiersResolver } from '../tiers/resolvers/tiers.resolver';
import { DistributorContractAreaResolver } from './resolvers/distributor-contract-area.resolver';
import { DistributorContractAreaDetailComponent } from './distributor-contract-area-detail/distributor-contract-area-detail.component';
import {GroupRightsResolver} from '../resolvers/group-rights.resolves';
import {ProductKindResolver} from '../resolvers/product-kind.resolver';

const routes: Routes = [
	{
		path: '', data: {breadcrumb: 'Verspreiders'}, resolve: {groupRights: GroupRightsResolver},
		children: [
			{
				path: 'aanmaken',
				data: {
					title: 'Verspreider Aanmaken',
					breadcrumb: 'Verspreider Aanmaken'
				},
				component: DistributorDetailComponent,
				resolve: {groupRights: GroupRightsResolver}
			},
			{
				path: ':distributorId', data: {breadcrumb: 'Verspreider Bewerken'},
				children: [
					{
						path: 'contracten/aanmaken',
						data: {title: 'Contract Aanmaken', breadcrumb: 'Contracten Aanmaken'},
						component: DistributorContractDetailComponent,
						resolve: {
							tiers: TiersResolver,
							groupRights: GroupRightsResolver
						}
					},
					{
						path: 'product/:productId',
						data: {title: 'Product Bewerken', breadcrumb: 'Product Bewerken'},
						component: DistributorProductDetailComponent,
						resolve: {
							distributorProduct: DistributorProductResolver,
							groupRights: GroupRightsResolver,
							productKinds: ProductKindResolver
						}
					},
					{
						path: 'product',
						data: {title: 'Product Aanmaken', breadcrumb: 'Product Aanmaken'},
						component: DistributorProductDetailComponent,
						resolve: {
							groupRights: GroupRightsResolver,
							productKinds: ProductKindResolver
						}
					},
					{
						path: 'contracten/:contractId', data: {breadcrumb: 'Contract Bewerken'},
						children: [
							{
								path: 'gebieden/aanmaken',
								data: {title: 'Contract Gebied Aanmaken', breadcrumb: 'Gebied Aanmaken'},
								component: DistributorContractAreaDetailComponent,
								resolve: {
									distributorContract: DistributorContractResolver,
									groupRights: GroupRightsResolver
								}
							},
							{
								path: 'gebieden/:areaId',
								data: {title: 'Contract Gebied Bewerken', breadcrumb: 'Gebied Bewerken'},
								component: DistributorContractAreaDetailComponent,
								resolve: {
									distributorContract: DistributorContractResolver,
									distributorContractArea: DistributorContractAreaResolver,
									groupRights: GroupRightsResolver
								}
							},
							{
								path: '',
								data: {title: 'Contract Bewerken'},
								component: DistributorContractDetailComponent,
								resolve: {
									tiers: TiersResolver,
									distributorContract: DistributorContractResolver,
									groupRights: GroupRightsResolver
								}
							}
						]
					},
					{
						path: '',
						data: {title: 'Verspreider Bewerken'},
						component: DistributorDetailComponent,
						resolve: {
							distributor: DistributorResolver,
							groupRights: GroupRightsResolver
						}
					}
				]
			},
			{
				path: '',
				data: {title: 'Verspreiders'},
				component: DistributorsComponent,
				resolve: {
					distributors: DistributorsResolver,
					groupRights: GroupRightsResolver
				}
			}
		]
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
	providers: [
		DistributorsResolver,
		DistributorResolver,
		DistributorContractResolver,
		DistributorContractAreaResolver,
		DistributorProductResolver
	]
})
export class DistributorsRoutingModule
{
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributors-routing.module.ts